import { FunctionComponent, useEffect, useState } from 'react';
import Tile from '../Shared/Tiles/TileV2';
import './MyInsightsTile.scss';
import BarChart from '../Charts/BarChart';
import { IBarChartData } from '../Models/BarChartModel';
import { IAgentQuoteData, IMyInsightsTile } from '../Models/MyInsightsModel';
import { useAgentQuoteData } from '../../../Foundation/User/QuoteDataContext';

const MyInsightsTile: FunctionComponent<any> = (props: IMyInsightsTile) => {
  const [barChartData, setBarChartData] = useState<IBarChartData[]>();
  const { agentQuoteData } = useAgentQuoteData();

  const buildChartData = (quoteData: IAgentQuoteData | null) => {
    const chartData: IBarChartData[] = [];
    if (props.item1Label) {
      const item1Value =
        quoteData && props.item1Field in quoteData ? Number(quoteData[props.item1Field as keyof IAgentQuoteData]) : 0;
      chartData.push({ name: props.item1Label, value: item1Value });
    }
    if (props.item2Label) {
      const item2Value =
        quoteData && props.item2Field in quoteData ? Number(quoteData[props.item2Field as keyof IAgentQuoteData]) : 0;
      chartData.push({ name: props.item2Label, value: item2Value });
    }
    if (props.item3Label) {
      const item3Value =
        quoteData && props.item3Field in quoteData ? Number(quoteData[props.item3Field as keyof IAgentQuoteData]) : 0;
      chartData.push({ name: props.item3Label, value: item3Value });
    }
    if (props.item4Label) {
      const item4Value =
        quoteData && props.item4Field in quoteData ? Number(quoteData[props.item4Field as keyof IAgentQuoteData]) : 0;
      chartData.push({ name: props.item4Label, value: item4Value });
    }
    return chartData;
  };

  useEffect(() => {
    setBarChartData(buildChartData(agentQuoteData));
  }, [agentQuoteData]);

  const getFooterDate = () => {
    const updatedDate = new Date(Date.now());
    updatedDate.setDate(updatedDate.getDate() - 1); // only back 1 day for 360 data
    return 'As of ' + (updatedDate.getMonth() + 1) + '/' + updatedDate.getDate() + '/' + updatedDate.getFullYear();
  };

  if (props) {
    return (
      <>
        <Tile title={props.title ? props.title : 'My insights'} showStatCode={props.showAgencyCode}>
          <div className="myinsights-container">
            {props.fullWidthContent ? (
              <div
                className="myinsights-columns-container"
                dangerouslySetInnerHTML={{ __html: props.fullWidthContent }}
              ></div>
            ) : (
              <div className="myinsights-columns-container">
                {!props.leftContent ? (
                  <div className="myinsights-left-column-container">
                    <div className="myinsights-barchart-container">
                      <div className="myinsightstitle">{props.subtitle}</div>
                      <div className="myinsights-barchart">
                        <BarChart barChartInput={barChartData} />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="myinsights-left-column-container"
                    dangerouslySetInnerHTML={{ __html: props.leftContent }}
                  ></div>
                )}
                <div
                  className="myinsights-right-column-container"
                  dangerouslySetInnerHTML={{ __html: props.rightContent }}
                ></div>
              </div>
            )}
          </div>
          {props.showAsOfDate && <div className="myinsights-footer">{getFooterDate()}</div>}
        </Tile>
      </>
    );
  } else {
    return <></>;
  }
};

export default MyInsightsTile;
